<div class="card bg-dark-lighter text-white">
  <div class="card-header text-yellow">
    {{ 'Discretionary Trading' | uppercase }}
  </div>
  <div class="card-body">
    <div class=" font-bold mb-2">IB List</div>
    <div class="table-responsive">
      <table class="rox-table table table-bordered ">
        <thead>
        <tr>
          <th class="text-center">ID</th>
          <th class="text-center">UserName</th>
          <th class="text-center">Email</th>
          <th class="text-center">Level</th>
          <th class="text-center">Total Trader</th>
          <th class="text-center">Total Sub IB</th>
          <th class="text-center">Total Sub IB Com.</th>
          <th class="text-end">Earning</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of ibs | paginate: {
                itemsPerPage: ibPageInfo.pageSize,
                currentPage: ibPageInfo.pageIndex,
                totalItems: ibPageInfo.totalRecord,
                id: 'ib-list'
              };
              let i = index"
        >
          <td class="text-center">{{ item.user_id }}</td>
          <td class="text-center">{{ item.first_name + ' ' +  item.last_name}}</td>
          <td class="text-center">{{ item.email }}</td>
          <td class="text-center">{{ level + 1 }}</td>
          <td class="text-center">{{ item.total_trader }}</td>
          <td class="text-center">{{ item.total_ib }}</td>
          <td class="text-end">
            <span >
              $ {{item.total_comm|DecimalPipe:"1.2-2"}}
            </span>
          </td>
          <td class="text-end">
            $ <span >{{item.earning |DecimalPipe:"1.2-2"}}</span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="clearfix mt-15 row">
      <div class="col">
        <div class="pagination-wrapper">
          <pagination-controls
            id="ib-list"
            (pageChange)="pageChanged($event, 'ib_list')"
            autoHide="true"
            responsive="true"
            previousLabel="Prev"
            nextLabel="Next"
            *ngIf="ibPageInfo.totalRecord > ibPageInfo.pageSize"
          >
          </pagination-controls>
        </div>
        <div class="ml-5" *ngIf="ibPageInfo.totalRecord > ibPageInfo.pageSize">
          <span>Page</span>
          <input
            style="width: 120px"
            class="ml-2 text-center"
            type="text"
            name="pageIndex"
            [(ngModel)]="ibPageManual"
            (keyup)="onKeyupPage($event, 'ib_list')"
            numberOnly
          />
          <button
            class="btn btn-primary ml-2"
            style="padding: 2px 0.75rem"
            (click)="pageChanged(ibPageManual, 'ib_list')"
          >
            Go
          </button>
        </div>
      </div>
      <div class="col-auto">
            <span class="data-info pull-right"
            >Found: {{ ibPageInfo.totalRecord }} record(s).</span
            >
      </div>
    </div>
    <hr />

    <div class=" font-bold mb-2">User List</div>
    <div class="table-responsive">
      <table class="rox-table table table-bordered ">
        <thead>
        <tr>
          <th class="text-center">ID</th>
          <th class="text-center">UserName</th>
          <th class="text-center">Email</th>
          <th class="text-center">Total Order</th>
          <th class="text-center">Total Lot</th>
          <th class="text-end">Total Lot Rebate</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of traders | paginate: {
                itemsPerPage: userPageInfo.pageSize,
                currentPage: userPageInfo.pageIndex,
                totalItems: userPageInfo.totalRecord,
                id: 'user-list'
              };
              let i = index"
        >
          <td class="text-center">{{ item.user_id }}</td>
          <td class="text-center">{{ item.first_name + ' ' +  item.last_name }}</td>
          <td class="text-center">{{ item.email }}</td>
          <td class="text-center">{{ item.total_order }}</td>
          <td class="text-center">{{ item.total_lot | number }}</td>
          <td class="text-end">
            <!-- <span labelNumber="{{item.earning}}" [currency]="currency"></span> -->
            $ <span >{{item.earning |DecimalPipe:"1.2-2"}}</span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="clearfix mt-15 row">
      <div class="col">
        <div class="pagination-wrapper">
          <pagination-controls
            id="user-list"
            (pageChange)="pageChanged($event, 'user_list')"
            autoHide="true"
            responsive="true"
            previousLabel="Prev"
            nextLabel="Next"
            *ngIf="userPageInfo.totalRecord > userPageInfo.pageSize"
          >
          </pagination-controls>
        </div>
        <div class="ml-5" *ngIf="userPageInfo.totalRecord > userPageInfo.pageSize">
          <span>Page</span>
          <input
            style="width: 120px"
            class="ml-2 text-center"
            type="text"
            name="pageIndex"
            [(ngModel)]="userPageManual"
            (keyup)="onKeyupPage($event, 'user_list')"
            numberOnly
          />
          <button
            class="btn btn-primary ml-2"
            style="padding: 2px 0.75rem"
            (click)="pageChanged(userPageManual, 'user_list')"
          >
            Go
          </button>
        </div>
      </div>
      <div class="col-auto">
            <span class="data-info pull-right"
            >Found: {{ userPageInfo.totalRecord }} record(s).</span
            >
      </div>
    </div>
</div>
</div>
